import type { UserRole } from '@micarahr/shared-types';

/**
 * The demonstration accounts, in one place.
 *
 * This lives outside `seed.ts` on purpose: the sign-in page and the auth
 * services need the list of accounts, but importing it from the seed pulled
 * the entire 96KB demonstration dataset into the production bundle. The seed
 * builds its system users from the same emails; this module is the part that
 * is cheap to ship and the seed is the part that is not.
 *
 * These credentials are fictional and development-only. Every surface that
 * renders or uses them is gated on `import.meta.env.PROD` so they are stripped
 * from production bundles, not merely hidden.
 */

/*
 * Statically empty in production builds. Both branches of these ternaries are
 * compile-time constants (Vite replaces `import.meta.env.*` before
 * minification), so a production bundle contains an empty array and an empty
 * string — the fictional emails and the shared password are deleted, not
 * hidden. The one exception is a deliberate prototype build, which sets
 * VITE_ALLOW_MOCK_IN_PRODUCTION and keeps its sign-in accounts.
 */

export const DEMO_PASSWORD =
  import.meta.env.PROD && import.meta.env.VITE_ALLOW_MOCK_IN_PRODUCTION !== 'true'
    ? ''
    : 'Demo123!';

export const DEMO_CREDENTIALS: {
  email: string;
  password: string;
  roles: UserRole[];
  name: string;
}[] =
  import.meta.env.PROD && import.meta.env.VITE_ALLOW_MOCK_IN_PRODUCTION !== 'true'
    ? []
    : [
        {
          email: 'company.admin@micarademo.local',
          password: DEMO_PASSWORD,
          roles: ['company_administrator'],
          name: 'John Aquino Villanueva',
        },
        {
          email: 'hr.admin@micarademo.local',
          password: DEMO_PASSWORD,
          roles: ['hr_administrator'],
          name: 'Maria Concepcion Santos',
        },
        {
          email: 'hr.officer@micarademo.local',
          password: DEMO_PASSWORD,
          roles: ['hr_officer'],
          name: 'Grace Lim Bautista',
        },
        {
          email: 'payroll.admin@micarademo.local',
          password: DEMO_PASSWORD,
          roles: ['payroll_administrator'],
          name: 'Alfonso Reyes Aquino',
        },
        {
          email: 'recruiter@micarademo.local',
          password: DEMO_PASSWORD,
          roles: ['recruiter'],
          name: 'Marco Santos Villanueva',
        },
        {
          email: 'manager@micarademo.local',
          password: DEMO_PASSWORD,
          roles: ['manager', 'department_head'],
          name: 'Michael Bautista Santos',
        },
        {
          email: 'auditor@micarademo.local',
          password: DEMO_PASSWORD,
          roles: ['auditor'],
          name: 'Cristina Del Rosario',
        },
      ];
